import { useTranslation } from 'react-i18next'
import { ErrorAlert } from '@repo/ui'
import SimpleApplyCancelDialog from '@/components/common/dialog/SimpleApplyCancelDialog'
import { Abruftoken } from '@/models/Abruftoken'
import useBfnStandortDenyMutation from '@/features/befehlsnachrichten/mutations/useBfnStandortDenyMutation'

export interface BfnDenyStandortBestaetigungDialogProps {
  abruftoken: Abruftoken
  state: boolean
  onClose: () => void
  'data-testid': string
}

export default function BfnDenyStandortBestaetigungDialog({
  abruftoken,
  state,
  onClose,
  'data-testid': testId
}: Readonly<BfnDenyStandortBestaetigungDialogProps>) {
  const { t } = useTranslation('bfnDetails')
  const { mutation } = useBfnStandortDenyMutation(abruftoken)

  const denyOnApply = () => {
    mutation.mutate(undefined, {
      onSuccess: () => {
        onClose()
      }
    })
  }

  return (
    <SimpleApplyCancelDialog
      title={t('dialog.deny_standort_bestaetigung.title')}
      state={state}
      onApply={denyOnApply}
      onCancel={onClose}
      applyButtonDisabled={mutation.isPending}
      applyButtonText={t('dialog.deny_standort_bestaetigung.apply')}
      cancelButtonText={t('dialog.deny_standort_bestaetigung.cancel')}
      data-testid={testId}
    >
      <p data-testid={`${testId}-text`}>
        {t('dialog.deny_standort_bestaetigung.text')}
      </p>
      {mutation.isError && (
        <ErrorAlert error={mutation.error} data-testid={`${testId}-error`}>
          {t('dialog.deny_standort_bestaetigung.error')}
        </ErrorAlert>
      )}
    </SimpleApplyCancelDialog>
  )
}
